'use strict';

DoohApps
    .factory('ConfigurationBlockHelper', function () {
        
        var configurationBlockType = {
            checkbox: 'Checkbox',
            effectColor: 'EffectColor',
            singleSelect: 'SingleSelect',
            languageSelect: 'LanguageSelect',
            effectSelect: 'EffectSelect',
            textInput: 'TextInput',
            colorVideoImagePicker: 'ColorVideoImagePicker',
            colVidImgPickerWithAttachments: 'ColVidImgPickerWithAttachments',
            positioning:'Positioning',
            slider:'Slider',
            region:'Region',
            webAppPreview: 'WebAppPreview',
            hidden: 'Hidden',
            simpleMediaPicker: 'SimpleMediaPicker',
            jsonEditor: 'JsonEditor',
            mediaList: 'MediaList',
            multiSelect: 'MultiSelect',
            textBlock: 'TextBlock'
        }

    return {
        getBlockTemplate: function (Block) {
            switch (Block.BlockName) {
                case configurationBlockType.checkbox:
                    Block.OptionsString = 'N/A';
                    Block.DefaultValue = '{"value":false}';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                case configurationBlockType.effectColor:
                    Block.OptionsString = 'N/A';
                    Block.DefaultValue = '{"Color": "#000000"}';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                case configurationBlockType.singleSelect:
                case configurationBlockType.multiSelect:
                    Block.OptionsString = '[{"label":"labelValue","res": "value","ticked": "false","icon":"url"},{"label":"labelValue","res": "value","ticked": "false","icon":"url"},{"label":"labelValue","res": "value","ticked": "false","icon":"url"},{"label":"labelValue","res": "value","ticked": "false","icon":"url"}]';
                    Block.DefaultValue = '[value]';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                case configurationBlockType.languageSelect:
                    Block.OptionsString = '[]';
                    Block.DefaultValue = '[]';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                case configurationBlockType.effectSelect:
                    Block.OptionsString = '[{"value":"ImagePath","URL":"ImagePath","selected":false},{"value":"ImagePath","URL":"ImagePath","selected":false},{"value":"ImagePath","URL":"ImagePath","selected":false},{"value":"ImagePath","URL":"ImagePath","selected":false},{"value":"ImagePath","URL":"ImagePath","selected":false},{"value":"ImagePath","URL":"ImagePath","selected":false}]';
                    Block.DefaultValue = '["ImagePath"]';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                case configurationBlockType.textInput:
                    Block.OptionsString = '{"inputType":"number"} OR {"inputType":"text"}';
                    Block.DefaultValue = '{"value":0} OR {"value":"default text"}';
                    Block.ValidationParameters = '[{"Type":"Required", "ErrorMessage":"Parameter is Required"},{"Type":"IntMin", "Value":0, "ErrorMessage":"Minimal amount is 0"},{"Type":"IntMax", "Value":500, "ErrorMessage":"Maximal amount is 500"}] OR [{"Type":"Required", "ErrorMessage":"Parameter is Required"}] OR N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                case configurationBlockType.colorVideoImagePicker:
                    Block.OptionsString = '[{ "color": true, "image": true, "video": true }]';
                    Block.DefaultValue = '{"Color" : "#7dc17a"} OR {"Image":{"FileURL":"pathToImage","IconUrl":"pathToImage"},"Active":"Img"} OR {"Video":{"FileURL":"pathToVideo","IconUrl":"pathToImage"},"Active":"Vid"}';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                case configurationBlockType.colVidImgPickerWithAttachments:
                    Block.OptionsString = '[{"image":true,"video":true,"objectCount":10}]';
                    Block.DefaultValue = '{"ValueArray":[]} OR {"ValueArray":[{"AttachmentTitle":"TitleHere","Active":"Med","Media":{"FileURL":"PathToMediaFile","IconUrl":"PathToMediaFileIconImage"}},{"AttachmentTitle":"TitleHere","Active":"Med","Media":{"FileURL":"PathToMediaFile","IconUrl":"PathToMediaFileIconImage"}}]}';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                case configurationBlockType.positioning:
                    Block.OptionsString = '{"FilePathName":"FilePath","LogoAspectName":"LogoAspect","LogoResizeName":"LogoResize","ULXName" : "LogoLeftTopX" , "ULYName": "LogoLeftTopY" , "LRXName": "LogoRightBottomX", "LRYName": "LogoRightBottomY"}';
                    Block.DefaultValue = '{"LogoHasLayer":false,"LogoAspect":false,"LogoResize":false} OR {"LogoHasLayer":false,"LogoAspect":false,"LogoResize":false,"Image":{"FileURL":"PathToMediaFile","IconUrl":"PathToMediaFileIconImage","Resolution":"mediaWith/mediaHeight"}}';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":{"landscape":true,"ratio169":true,"areaBackground":null,"areaBackgroundPosition":null}}'
                    break;
                case configurationBlockType.slider:
                    Block.OptionsString = '{"minLabel":"label","maxLabel":"label","minValue":0,"maxValue":1,"step":0.1}';
                    Block.DefaultValue = '{"value":value}';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                case configurationBlockType.region:
                    Block.OptionsString = '{"ULXName" : "RegionLeftTopX" , "ULYName": "RegionLeftTopY" , "LRXName": "RegionRightBottomX", "LRYName": "RegionRightBottomY"}';
                    Block.DefaultValue = '{}';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":{"landscape":true,"ratio169":true,"areaBackground":null,"areaBackgroundPosition":null}}'
                    break;
                case configurationBlockType.webAppPreview:
                    Block.OptionsString = '{"baseURL": "yourURLhere"}';
                    Block.DefaultValue = '{}';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                case configurationBlockType.hidden:
                    Block.OptionsString = 'N/A';
                    Block.DefaultValue = '';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                case configurationBlockType.simpleMediaPicker:
                    Block.OptionsString = '[{"image": true, "video": true }]';
                    Block.DefaultValue = '{} OR {"Image":{"FileURL":"pathToImage","IconUrl":"pathToImage"} OR {"Video":{"FileURL":"pathToVideo","IconUrl":"pathToImage"}';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                case configurationBlockType.jsonEditor:
                    Block.OptionsString = '{"mode": "tree", "modes": ["tree","form","code","text"], "editable": true, "history": true, "name": "playlist"}';
                    Block.DefaultValue = '{"scenes":[{"delay":0.1,"duration":5.5,"maxRows":2,"maxColumns":3,"blocks":[{"x":1,"y":1,"width":3,"height":2,"animOut":{"delay":2,"type":1,"duration":8},"animReveal":{"delay":2,"type":1,"duration":5},"type":1,"typeName":"Facebook","searchParams":{"userId":"YoloMoloTolo"}}]}]}';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                case configurationBlockType.mediaList:
                    Block.OptionsString = '{"images": true, "videos": false, "maxFiles": 999, "disableFilters": true}';
                    Block.DefaultValue = '[]';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                case configurationBlockType.textBlock:
                    Block.OptionsString = 'N/A';
                    Block.DefaultValue = '{"value": ""}';
                    Block.ValidationParameters = 'N/A';
                    Block.Settings = '{"Interaction":"N/A"}';
                    break;
                default:
                    Block.OptionsString = '';
                    Block.DefaultValue = '';
                    Block.ValidationParameters = '';
                    break;

            }
            Block.GridData = getGridData(Block.BlockName);
        },
        getExtraSettings: getExtraSettings,
        getGridData: getGridData,
        getGridsterOptions: function (move) {
            var options = {
                columns: 6, // the width of the grid, in columns
                width: 'auto', // can be an integer or 'auto'. 'auto' scales gridster to be the full width of its containing element
                colWidth: 'auto', // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
                rowHeight: 70, // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets.
                margins: [10, 10], // the pixel distance between each widget
                outerMargin: true, // whether margins apply to outer edges of the grid
                isMobile: false, // stacks the grid items if true
                mobileBreakPoint: 600, // if the screen is not wider that this, remove the grid layout and stack the items
                mobileModeEnabled: false, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
                minColumns: 1, // the minimum columns the grid must have
                minRows: 1, // the minimum height of the grid, in rows
                maxRows: 100,
                defaultSizeX: 3, // the default width of a gridster item, if not specifed
                defaultSizeY: 1, // the default height of a gridster item, if not specified
                minSizeX: 3, // minimum column width of an item
                maxSizeX: 6, // maximum column width of an item
                minSizeY: 1, // minumum row height of an item
                maxSizeY: 6, // maximum row height of an item
                resizable: {
                    enabled: false,
                },
                draggable: {
                    enabled: false,
                }

            };
            if (move) {
                options.pushing = true;// whether to push other items out of the way on move or resize
                options.floating = true;// whether to automatically float items up so they stack (you can temporarily disable if you are adding unsorted items with ng-repeat)
                options.swapping = true;// whether or not to have items of the same size switch places instead of pushing down if they are the same size
                options.draggable.enabled = true;// whether dragging items is supported
                options.draggable.handle = '.option-bar';
            }
            return options;
        },
        loadBlocks: function (blocks, appConfigs) {
            angular.forEach(blocks, function (blockVal) {
                var found = false;

                angular.forEach(appConfigs, function (configVal) {
                    if (blockVal.BlockID == configVal.BlockID) {
                        blockVal.ConfigurationValue = configVal.ConfigurationValue;
                        found = true;
                    }
                });

                if (!found) {
                    appConfigs.push({
                        ConfigurationName: blockVal.Label,
                        BlockID: blockVal.BlockID,
                        ConfigurationValue: blockVal.DefaultValue
                    });
                    blockVal.ConfigurationValue = blockVal.DefaultValue;
                }

            });
        },
        configurationBlockType: configurationBlockType//GetBlockNames
    }

    function getExtraSettings(BlockName) {
        switch (BlockName) {
            case configurationBlockType.checkbox:
            case configurationBlockType.effectColor:
            case configurationBlockType.singleSelect:
            case configurationBlockType.multiSelect:
            case configurationBlockType.languageSelect:
            case configurationBlockType.effectSelect:
            case configurationBlockType.textInput:
            case configurationBlockType.slider:
            case configurationBlockType.colorVideoImagePicker:
            case configurationBlockType.colVidImgPickerWithAttachments:
            case configurationBlockType.webAppPreview:
            case configurationBlockType.hidden:
            case configurationBlockType.simpleMediaPicker:
            case configurationBlockType.mediaList:
            case configurationBlockType.jsonEditor:
            case configurationBlockType.textBlock:
                return '{"Interaction":"N/A"}';
            case configurationBlockType.positioning:
                return '{"Interaction":{"landscape":true,"ratio169":true,"areaBackground":null,"areaBackgroundPosition":null}}';
            case configurationBlockType.region:
                return '{"Interaction":{"landscape":true,"ratio169":true,"areaBackground":null,"areaBackgroundPosition":null}}';
            default:
                return null;

        }
    }

    function getGridData(BlockName) {
        switch (BlockName) {
            case configurationBlockType.checkbox:
            case configurationBlockType.effectColor:
            case configurationBlockType.singleSelect:
            case configurationBlockType.multiSelect:
            case configurationBlockType.languageSelect:
            case configurationBlockType.textInput:
            case configurationBlockType.hidden:
                return '{ "row": 0, "col": 0,"sizeX": 3, "sizeY":1 }';
            case configurationBlockType.effectSelect:
            case configurationBlockType.colorVideoImagePicker:
            case configurationBlockType.simpleMediaPicker:
                return '{ "row": 0, "col": 0,"sizeX": 3, "sizeY":3 }';
            case configurationBlockType.slider:
            case configurationBlockType.webAppPreview:
                return '{ "row": 0, "col": 0,"sizeX": 3, "sizeY":2 }';
            case configurationBlockType.colVidImgPickerWithAttachments:
                return '{ "row": 0, "col": 0,"sizeX": 6, "sizeY":5 }';
            case configurationBlockType.positioning:
                return '{ "row": 0, "col": 0, "sizeX": 6, "sizeY":4 }';
            case configurationBlockType.region:
                return '{ "row": 0, "col": 0, "sizeX": 6, "sizeY":3 }';
            case configurationBlockType.mediaList:
            case configurationBlockType.jsonEditor:
            case configurationBlockType.textBlock:
                return '{ "row": 0, "col": 0, "sizeX": 6, "sizeY": 6 }';
            case '':
                return '{ "row": 0, "col": 0, "sizeX": 3, "sizeY":3 }';
            default:
                return null;

        }
    }

});